import { colors, RadioButton } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

export const RadioButtonStyled = styled(RadioButton)`
  border-radius: 5px;
  padding: 0.5rem 1rem;

  ${({ checked }): CSSProp =>
    checked
      ? css`
          font-weight: 700;
          background-color: ${colors.blue[100]};

          & label {
            color: ${colors.blue[600]};
          }
        `
      : css`
          & label {
            color: ${colors.neutral[900]};
          }
        `};

  ${({ disabled }): CSSProp =>
    disabled &&
    css`
      & label {
        color: ${colors.neutral[600]};
      }
    `};
`;
